/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useContext, useState } from 'react';
import { StyleSheet, TouchableHighlight, View } from 'react-native';
import DyteClient, { DyteParticipant } from '@dytesdk/web-core';
import { SvgXml } from 'react-native-svg';
import { defaultIconPack, IconPack } from '../lib/icons';
import { DyteI18n, useLanguage } from '../lib/lang';
import PeerView from '../PeerView';
import DyteAudioVisualizer from './DyteAudioVisualizer';
import DyteNameTag from './DyteNameTag';
import { DyteUIContext } from '../lib/context-provider/ui-context';

export default function ({
  participant,
  hideFullScreenButton = false,
  meeting,
  iconPack = defaultIconPack,
  nameTagPosition = 'bottom-left',
  size = 'sm',
  variant = 'solid',
  t,
}: {
  participant: DyteParticipant;
  hideFullScreenButton?: boolean;
  meeting?: DyteClient;
  iconPack?: IconPack;
  nameTagPosition?:
    | 'bottom-center'
    | 'bottom-left'
    | 'bottom-right'
    | 'top-center'
    | 'top-left'
    | 'top-right';
  size?: 'lg' | 'md' | 'sm' | 'xl';
  variant?: 'gradient' | 'solid';
  t?: DyteI18n;
}) {
  const defaultLang = useLanguage();
  t = t ?? defaultLang;
  iconPack = iconPack ?? defaultIconPack;
  const { storeStates, setStates } = useContext(DyteUIContext);
  const { colors } = storeStates.designSystem;
  const [dimensions, setDimensions] = useState({
    width: 0,
    height: 0,
  });
  const styles = StyleSheet.create({
    container: {
      flex: 1,
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius: 8,
      margin: '2%',
      width: '100%',
      backgroundColor: colors.background[900],
    },
    infoContainer: {
      position: 'absolute',
      bottom: 10,
      left: 10,
    },
    fullscreenButton: {
      position: 'absolute',
      zIndex: 1,
      right: 10,
      top: 10,
      borderRadius: 4,
      backgroundColor: colors.background[900],
    },
  });
  return (
    <View
      style={styles.container}
      onLayout={(event) => {
        setDimensions({
          width: event.nativeEvent.layout.width,
          height: event.nativeEvent.layout.height,
        });
      }}
    >
      <View>
        <PeerView
          participant={participant}
          width={dimensions.width - 3}
          height={dimensions.height - 6}
          isScreenshare={true}
          mirrorVideo={true}
        />
      </View>
      {!hideFullScreenButton && (
        <View style={styles.fullscreenButton}>
          <TouchableHighlight
            onPress={() => {
              setStates({
                ...storeStates,
                activeFullscreen: !storeStates.activeFullscreen,
              });
            }}
            // eslint-disable-next-line react-native/no-inline-styles
            style={{
              padding: 4,
            }}
          >
            <SvgXml
              xml={(storeStates.activeFullscreen
                ? iconPack.full_screen_minimize
                : iconPack.full_screen_maximize
              ).replace('currentColor', colors.text)}
              width={25}
              height={25}
            />
          </TouchableHighlight>
        </View>
      )}
      <View style={styles.infoContainer}>
        <DyteNameTag meeting={meeting} participant={participant}>
          {participant.screenShareTracks.audio ? (
            <DyteAudioVisualizer participant={participant} />
          ) : (
            // eslint-disable-next-line react-native/no-inline-styles
            <View style={{ padding: 4 }}>
              <SvgXml
                xml={iconPack.mic_off.replace('currentColor', colors.danger)}
                width={16}
                height={16}
              />
            </View>
          )}
        </DyteNameTag>
      </View>
    </View>
  );
}
